module.exports = __webpack_public_path__ + "img/c01_unitsarissophoroi_Normal_ua.8d9a2b9c.webp";